export default __webpack_public_path__ + "static/media/preloader.f5748b97.gif";